import { ApiError, apiFetch } from '../../lib/api'
import type { InstrumentDateRequest } from './datePlan'
import type { Catalogue, EditResult, EditScope, EditTarget, Preview } from './contract'

export const capabilities = () =>
  apiFetch<{
    enabled: boolean
    record_edits_enabled?: boolean
    optional_explanations_enabled?: boolean
  }>('/api/navigation/capabilities')
export const catalogue = (kind: string) => apiFetch<Catalogue>(`/api/record-fields/${kind}`)
export const preview = (target: EditTarget, scope: EditScope, datePlan?: InstrumentDateRequest) =>
  apiFetch<Preview>('/api/record-edits/preview', {
    method: 'POST',
    body: JSON.stringify({
      target_type: target.kind,
      target_id: target.id,
      scope,
      ...(datePlan ? { date_plan: datePlan } : {}),
    }),
  })
export const readEdit = (id: string) =>
  apiFetch<EditResult>(`/api/record-edits/${encodeURIComponent(id)}`)
export function errorText(error: unknown): string {
  if (
    error instanceof ApiError &&
    error.body &&
    typeof error.body === 'object' &&
    'detail' in error.body
  ) {
    const detail = (error.body as { detail: unknown }).detail
    if (typeof detail === 'string') return detail
    if (Array.isArray(detail))
      return detail
        .map((row) => [row.loc?.slice(-1)[0], row.msg].filter(Boolean).join(': '))
        .join(' · ')
    if (detail && typeof detail === 'object' && 'message' in detail) return String(detail.message)
  }
  return error instanceof Error ? error.message : 'The Record edit could not be loaded.'
}
